export default {
  onboarding: {
    actions: {
      mainBlue: 'Comience el cuestionario'
    }
  },
  details: {
    stepTitle: 'Información sobre la solicitud',
    aboutProperty: 'Informaciones complementarias',
    title: 'Detalles de los bienes dañados:',
    errorMsgInputTxt: 'Campos obligatorios',
    errorMsgGeneral: 'Revise el formulario antes de continuar',
    errorImages: 'Por favor, añada las fotos antes de continuar',
    warningMsg: 'Si esta información está incompleta o es incorrecta, póngase en contacto con su representante habitual de Allianz.',
    address: {
      literal: 'Dirección',
      placeholder: 'Introduce una ubicación'
    },
    zipCode: {
      literal: 'Código postal'
    },
    propertyType: {
      literal: 'Tipo de propiedad',
      options: {
        appartment: 'Apartamento',
        maison: 'Casa',
        local_commercial: 'Local comercial'
      }
    },
    residentType: {
      literal: 'Tipo de residente',
      options: {
        propietarie: 'Propietario',
        locataire: 'Inquilino',
        propietarie_non_occupant: 'Arrendatario'
      }
    },
    moreThanTwoYears: {
      literal: 'Edad del inmueble',
      options: {
        more: 'Más de 2 años',
        less: 'Menos de 2 años'
      }
    },
    observations: {
      literal: 'Observaciones'
    },
    map: {
      empty: {
        title: 'No hay ubicación',
        text: 'Introduce una ubicación válida'
      }
    },
    textArea: {
      placeHolder: 'Longitud del texto limitada a 255 caracteres como máximo'
    }
  },
  closing: {
    actions: {
      mobilierButton: 'Continúa con daños en muebles'
    }
  },
  compensationType: {
    title: '¿Cuál es su solución preferida para los daños materiales?',
    subtitle: 'Acerca de los daños de su propiedad ',
    propertyDamage: 'Daños materiales declarados',
    text: 'Para ello, ofrecemos tres posibles soluciones:',
    recommended: 'Nuestra recomendación!',
    amount: 'Importe reembolsado:',
    e2eCompensations: {
      ourRecommendation: 'Nuestra recomendación',
      gagDetail: {
        title: 'Hacer el trabajo yo mismo',
        text: 'Si opta por esta solución, recibirá la siguiente indemnización inmediata, que le permitirá realizar las obras usted mismo y devolver su propiedad a su estado original.',
        link: 'Elija esta solución'
      },
      billma: {
        title: 'Elegir mi propio artesano',
        text: 'Adjunte el presupuesto del artesano de su elección para recibir su indemnización.',
        link: 'Elija esta solución'
      },
      renDetail: {
        title: 'Elegir un artesano autorizado por Allianz',
        text: 'Comuníquenos su disponibilidad para que un colaborador autorizado por Allianz acuda a reparar sus daños. Se beneficiará de una reparación de calidad sin trámites administrativos. Sólo tendrás que pagar la franquicia.',
        link: 'Elija esta solución'
      }
    }
  },
  compensationMobilier: {
    title: 'Con respecto a los daños a su propiedad',
    subtitle: 'Monto de la compensación',
    total: 'Total:',
    totalAmount: 'Compensación total',
    actions: {
      primary: 'Sí, acepto la compensación propuesta',
      secondary: 'Quiero hablar con un asesor'
    }
  }
}
